"use client"

import { Binoculars } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BinocularsIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BinocularsIcon = component(Icon)({ as: Binoculars })
